import { render, staticRenderFns } from "./schedule_match_list.vue?vue&type=template&id=71709d4d&scoped=true"
import script from "./schedule_match_list.vue?vue&type=script&lang=js"
export * from "./schedule_match_list.vue?vue&type=script&lang=js"
import style0 from "./schedule_match_list.vue?vue&type=style&index=0&id=71709d4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71709d4d",
  null
  
)

export default component.exports